'use client';

import { FC } from 'react';

import { useAuthentication } from '@ravago/shared/authentication';
import { DynamicPageContentType } from '@ravago/shared/page-data/models/contentful';
import { NormalizedHeader, NormalizedNavigationItem } from '@ravago/shared/page-data/models/contentful-mapped';
import { Customer } from '@ravago/shared/page-data/models/features';
import { CustomerSwitchButton } from '@ravago/shared/page-elements-radiance/components/shared/customer-switch-button/customer-switch-button';
import { LogoutButton } from '@ravago/shared/page-elements-radiance/components/shared/logout-button/logout-button';
import { MenuItem } from '@ravago/shared/page-elements-radiance/components/shared/menu-item/menu-item';
import { Alert } from '@ravago/shared/radiance/components/alert/components/Alert/Alert';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Divider } from '@ravago/shared/radiance/components/divider/components/Divider/Divider';
import { useBreakpoint } from '@ravago/shared/radiance/hooks/useBreakpoint/useBreakpoint';
import { useTranslations } from '@ravago/shared/translations/client';

import Link from 'next/link';

interface Props {
  locale: string;
  profileMenu?: NormalizedHeader | null;
  currentCustomer?: Customer;
  isFirstLogin?: boolean;
  dynamicPageUrls?: { [key in DynamicPageContentType]?: string };
  onClick?: () => void;
  onCustomerSwitchClick?: () => void;
  onFirstLoginDismiss?: () => void;
}

export const ProfileMenu: FC<Props> = ({ locale, profileMenu, currentCustomer, isFirstLogin, dynamicPageUrls, onClick, onCustomerSwitchClick, onFirstLoginDismiss }) => {
  const translate = useTranslations();

  const { phone } = useBreakpoint();

  const { user } = useAuthentication();

  const handleCustomerSwitchClick = () => {
    onCustomerSwitchClick?.();
    onClick?.();
  };

  if (!user) return null;

  return (
    <Box gap="sm" spacing={{ x: !phone ? 'sm' : 'none' }} direction="column" width={!phone ? '408px' : '100%'} height="100%" maxHeight={!phone ? '70vh' : '100vh'} overflowY="auto">
      <Box className="custom-scrollbar" height="100%" overflowY="auto" gap="sm" direction="column">
        {isFirstLogin && (
          <Alert headline={translate('page-consumer.header.first-login.header')} variant="info" closable onClose={onFirstLoginDismiss}>
            {translate('page-consumer.header.first-login.info')}
          </Alert>
        )}

        <MenuItem locale={locale} navigationItems={(profileMenu?.navigationItems as NormalizedNavigationItem[]) ?? []} dynamicPageUrls={dynamicPageUrls} linkComponent={Link} cyLabel="profile-menu-item" onClick={onClick} />
      </Box>
      <Divider />
      <CustomerSwitchButton currentCustomer={currentCustomer} cyLabel="profile-menu-item-switch-customer" onClick={handleCustomerSwitchClick} />
      <LogoutButton cyLabel="profile-menu-item-sign-out" onClick={onClick} />
    </Box>
  );
};

export default ProfileMenu;
